import { ErrorCode, NotificationTypeEnum } from "./enums";
import { Util } from "@auvious/common";
export interface INotification {
  id: string;
  type: NotificationTypeEnum;
  title: string;
  options?: INotificationOptions;
}

export interface INotificationOptions {
  body?: string;
  image?: URL;
  ttl?: number;
  error?: Error;
  errorCode?: ErrorCode;
  sound?: boolean;
  onApprove?: () => void;
  onReject?: () => void;
}

export class ConfirmNotification implements INotification {
  public id: string;
  public type = NotificationTypeEnum.confirm;

  private _confirmedCb: () => void;
  private _canceledCb: () => void;

  constructor(public title: string, public options?: INotificationOptions) {
    this.id = Util.uuidgen();
    this._confirmedCb = options?.onApprove;
    this._canceledCb = options?.onReject;
  }

  confirm() {
    this._confirmedCb?.();
  }

  cancel() {
    this._canceledCb?.();
  }
}
